import {
  typedCollection,
  typedDoc,
  getCollection,
  addDoc,
  deleteDocument,
  orderBy,
  serverTimestamp,
} from '@/lib/firebase/firestore'
import type { ProjectTaskCommentDocument } from '@/types'

const commentsCol = (boardId: string, taskId: string) =>
  typedCollection<ProjectTaskCommentDocument>(
    `projectBoards/${boardId}/tasks/${taskId}/comments`
  )

export const projectBoardCommentsService = {
  list(boardId: string, taskId: string) {
    return getCollection(commentsCol(boardId, taskId), orderBy('createdAt', 'asc'))
  },

  async add(
    boardId: string,
    taskId: string,
    input: { bodyMarkdown: string; authorId: string; authorName: string }
  ): Promise<string> {
    const ref = await addDoc(commentsCol(boardId, taskId), {
      taskId,
      boardId,
      bodyMarkdown: input.bodyMarkdown,
      authorId: input.authorId,
      authorName: input.authorName,
      createdAt: serverTimestamp(),
      updatedAt: serverTimestamp(),
    } as unknown as ProjectTaskCommentDocument)
    return ref.id
  },

  remove(boardId: string, taskId: string, commentId: string): Promise<void> {
    return deleteDocument(
      typedDoc<ProjectTaskCommentDocument>(
        `projectBoards/${boardId}/tasks/${taskId}/comments`,
        commentId
      )
    )
  },
}
